import { renderButton_unstable } from '@fluentui/react-button';

/**
 * Renders the final JSX of the Button component, given the state.
 */
export const renderButton = renderButton_unstable;
